// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1BulkImportResponseSchema = z.object({
  deleted_ids: z.array(z.number().int()).describe("IDs of successfully deleted entries"),
  created_ids: z.array(z.number().int()).describe("IDs of successfully created entries"),
  updated_ids: z.array(z.number().int()).describe("IDs of successfully updated entries"),
  errors: z.object({
    create: z.optional(z.array(z.object({}))),
    update: z.optional(z.array(z.object({}))),
    delete: z.optional(z.array(z.object({}))),
  }).describe("Errors encountered during import"),
  job: z.object({}).describe("Job details if operation is asynchronous (100+ records)").nullish(),
});
